import * as z from "zod";
import { SCOPE_MANAGE_GRANTS_PERMISSION } from "../rbac/roles";
import { mutator } from "./mutator";

// A reviewer rejecting a request (the requester withdrawing their own is
// cancelGrantRequest). Same authority as approving it — you can reject a share
// request only if you could have granted it directly.
export const dismissGrantRequest = mutator({
  schema: z.object({ requestId: z.string() }),
  resolve: {
    request: { kind: "grantRequest", from: "requestId" },
  },
  permissions: [
    {
      permission: ({ args }) =>
        SCOPE_MANAGE_GRANTS_PERMISSION[args.request.scopeKind],
      scopeId: ({ args }) => args.request.scopeId,
    },
  ],
  fn: async ({ tx, args: { request } }) => {
    await tx.mutate.grantRequests.delete({ id: request.id });
  },
});
